(() => {
  if (customElements.get('sm-home-wellness-swipe')) return;
  customElements.define('sm-home-wellness-swipe', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.grid = this.root?.querySelector('.collection-list--grid');
      if (!this.grid) return;
      this.original = [...this.grid.querySelectorAll(':scope > .collection-list--card')];
      this.outdoor = this.dataset.outdoorIndex !== '' ? this.original[Number(this.dataset.outdoorIndex)] : null;
      this.mobile = matchMedia('(max-width: 767px)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.original.forEach(card => {
        const content = card.querySelector('.collection-card--content');
        if (!content || content.querySelector('.sm-wellness-link-arrow')) return;
        const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        arrow.setAttribute('class', 'sm-wellness-link-arrow');
        arrow.setAttribute('viewBox', '0 0 24 24');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.innerHTML = '<path d="M4 12h15m-6-6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';
        content.append(arrow);
      });
      this.dots = this.querySelector('.sm-wellness-dots');
      this.root.classList.add('sm-wellness-mobile');
      this.applyLayout = () => {
        const order = this.mobile.matches && this.outdoor
          ? [this.outdoor, ...this.original.filter(card => card !== this.outdoor)] : this.original;
        order.forEach(card => this.grid.append(card));
        this.dots.replaceChildren();
        order.forEach(card => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', card.querySelector('.collection-card--title')?.textContent.trim() || 'Collection');
          dot.addEventListener('click', () => this.goTo(card), options);
          dot.card = card;
          this.dots.append(dot);
        });
        this.grid.scrollLeft = 0;
        this.update();
      };
      this.update = () => {
        const buttons = [...this.dots.children];
        const visible = buttons.filter(dot => dot.card.getClientRects().length && getComputedStyle(dot.card).display !== 'none');
        const edge = this.grid.getBoundingClientRect().left + 16;
        let active = visible[0];
        for (const dot of visible) {
          if (Math.abs(dot.card.getBoundingClientRect().left - edge) < Math.abs(active.card.getBoundingClientRect().left - edge)) active = dot;
        }
        buttons.forEach(dot => {
          const hidden = !visible.includes(dot);
          if (dot.hidden !== hidden) dot.hidden = hidden;
          const current = String(dot === active);
          if (dot.getAttribute('aria-current') !== current) dot.setAttribute('aria-current', current);
          const label = dot.card.querySelector('.collection-card--title')?.textContent.trim() || 'Collection';
          if (dot.getAttribute('aria-label') !== label) dot.setAttribute('aria-label', label);
        });
        const hidden = !this.mobile.matches || visible.length < 2;
        if (this.hidden !== hidden) this.hidden = hidden;
      };
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.grid.addEventListener('scroll', this.schedule, { ...options, passive: true });
      this.mobile.addEventListener('change', this.applyLayout, options);
      this.dots.addEventListener('keydown', event => {
        const buttons = [...this.dots.children].filter(dot => !dot.hidden);
        const index = buttons.indexOf(event.target);
        let target;
        if (event.key === 'ArrowRight') target = buttons[Math.min(index + 1, buttons.length - 1)];
        if (event.key === 'ArrowLeft') target = buttons[Math.max(index - 1, 0)];
        if (event.key === 'Home') target = buttons[0];
        if (event.key === 'End') target = buttons.at(-1);
        if (target) { event.preventDefault(); target.focus(); this.goTo(target.card); }
      }, options);
      this.applyLayout();
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.grid);
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(this.grid, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    goTo(card) {
      const left = this.grid.scrollLeft + card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left - 16;
      this.grid.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.mutations?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
})();
